/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CombinedPackage = {
    id?: number;
    user_id?: string;
    description?: string | null;
    weight: number;
    length: number;
    width: number;
    height: number;
    image?: string | null;
    custom_value: number;
    quantity?: number;
    shipping_cost?: number | null;
    state?: CombinedPackage.state;
    /**
     * user note for package
     */
    note?: string | null;
    created_at?: string;
    updated_at?: string;
};
export namespace CombinedPackage {
    export enum state {
        REQUESTED = 'REQUESTED',
        APPROVED = 'APPROVED',
        DRAFT = 'DRAFT',
        DONE = 'DONE',
    }
}

